import { z } from "zod";

export const invoiceRequestSchema = z.object({
    invoiceCycle: z.string(),
    comments: z.string().optional(),
    email: z.string(),
    company: z.string()
});
